import styled from "styled-components";

const Div = styled.div`
  margin-bottom: 20px;
`;

export default Div;
